module.exports = __webpack_public_path__ + "static/auto_policy_updates_mobile-afea794c0c8f1c2e10414b14f40a28ea.webp";